import { all } from "redux-saga/effects";
import Balance from "./balance/saga";
import customerSaga from "./customer/saga";
import UserPrefSaga from "./auth/saga";
import UserAuthSaga from "./user/saga";

export default function* rootSaga() {
  yield all([Balance(), customerSaga(), UserPrefSaga(), UserAuthSaga]);
}
